"use client";

import { BuilderContent } from "@builder.io/sdk";
import { LoggedOutHomePage } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/LoggedOutHomePage";
import React from "react";

export const RenderHomePage = ({
  builderPromise,
}: {
  builderPromise?: Promise<BuilderContent | undefined>;
}) => {
  return <LoggedOutHomePage builderPromise={builderPromise} />;
};
